import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { X, Plus } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Switch } from '../ui/switch';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { API, errMsg } from './taUtils';

export function TurnaroundSettingsCard({ settings, editable, headers, onSaved }) {
    const [causes, setCauses] = useState(settings?.delay_causes || []);
    const [newCause, setNewCause] = useState('');
    useEffect(() => { setCauses(settings?.delay_causes || []); }, [settings]);

    const save = async (patch, msg) => {
        try { await axios.put(`${API}/turnaround/settings`, patch, { headers }); toast.success(msg); onSaved(); }
        catch (e) { toast.error(errMsg(e)); }
    };
    const addCause = () => {
        const c = newCause.trim();
        if (!c || causes.includes(c)) return;
        setCauses([...causes, c]);
        setNewCause('');
    };

    return (
        <Card className="card-aviation" data-testid="ta-settings-card">
            <CardContent className="p-4 space-y-4">
                <div className="flex items-center justify-between gap-3">
                    <div>
                        <p className="text-sm font-semibold">Mostrar actividades previas a la llegada en el Gantt</p>
                        <p className="text-xs text-muted-foreground">Ej.: check-in, plan de vuelo. Cada usuario puede ocultarlas temporalmente en su vista.</p>
                    </div>
                    <Switch checked={settings?.show_pre_arrival !== false} disabled={!editable} onCheckedChange={v => save({ show_pre_arrival: v }, 'Preferencia guardada')} data-testid="ta-settings-pre" />
                </div>
                <div className="space-y-2">
                    <p className="text-sm font-semibold">Causas de demora</p>
                    <div className="flex flex-wrap gap-1.5" data-testid="ta-settings-causes">
                        {causes.map(c => (
                            <span key={c} className="inline-flex items-center gap-1 rounded-full border border-border/50 bg-muted/20 px-2.5 py-1 text-xs">
                                {c}{editable && <button type="button" onClick={() => setCauses(causes.filter(x => x !== c))} aria-label={`Quitar ${c}`} data-testid={`ta-cause-remove-${c}`}><X className="w-3 h-3" /></button>}
                            </span>
                        ))}
                    </div>
                    {editable && (
                        <div className="flex flex-wrap gap-2">
                            <Input value={newCause} onChange={e => setNewCause(e.target.value)} onKeyDown={e => e.key === 'Enter' && addCause()} placeholder="Nueva causa" className="h-8 w-60 text-xs" data-testid="ta-cause-new" />
                            <Button size="sm" variant="outline" onClick={addCause} data-testid="ta-cause-add"><Plus className="w-3.5 h-3.5 mr-1" />Agregar</Button>
                            <Button size="sm" onClick={() => save({ delay_causes: causes }, 'Causas guardadas')} data-testid="ta-causes-save">Guardar causas</Button>
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
